/* eslint-disable sonarjs/cognitive-complexity */
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import COOKIES from '../../config/cookies/cookies';
import { isNationalDeal } from '../../helpers/deals';
import { DiscountCoupon } from '../forms/Subscriber/components/DiscountCoupon';
import ImageComponent from './ImageComponent';
import Review from './Review';

const PriceSplat = dynamic(() => import('./PriceSplat'), {
  ssr: false,
});

const FindFeed = ({ deals, isMobile = false, ssr, isSpaPage }) => {
  const height = isMobile ? 275 : 384;
  const width = isMobile ? 412 : 573;
  const [enableWelcome, setEnableWelcome] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem('src') === 'welcome' &&
      Cookies.load(COOKIES.customerToken)
    ) {
      setEnableWelcome(true);
      localStorage.removeItem('src');
    }
  }, []);

  return (
    <>
      <div className="container">
        {deals.map((deal, index) => {
          const priority = isMobile ? index < 2 : index < 4;
          const isNational = isNationalDeal(deal);
          const isPPVisible = !isSpaPage && deal?.minPostagePrice !== undefined;

          return (
            <div className="deal-card" key={deal.id}>
              <a
                href={`${
                  deal.evergreenUrl
                    ? deal.evergreenUrl
                    : process.env.NEXT_PUBLIC_BASE_ROOT_URL + deal.urlPath
                }`}
              >
                <div className="image-box">
                  <PriceSplat
                    deal={deal}
                    isNationalDeal={isNational}
                    isPPVisible={isPPVisible}
                    isVisible={!ssr}
                  />
                  <ImageComponent
                    deal={deal}
                    height={height}
                    priority={priority}
                    width={width}
                  />
                </div>
                <div className="text">
                  <div className="left">
                    <h3 className="headline-text">{deal.headline}</h3>
                    {!isSpaPage && deal?.minPostagePrice !== undefined && (
                      <p className="grey-text">
                        {deal.minPostagePrice === 0
                          ? isMobile
                            ? 'Click & Collect for '
                            : 'from'
                          : deal.postagePriceText}
                        {deal.minPostagePrice === 0
                          ? isMobile
                            ? 'FREE'
                            : ` ${deal.currency === 'gbp' ? '£' : '€'}${
                                deal.paidMinPostagePrice
                              } P&P`
                          : ` ${deal.currency === 'gbp' ? '£' : '€'}${
                              deal.minPostagePrice
                            } P&P`}
                      </p>
                    )}
                    <Review deal={deal} />
                  </div>
                  <div className="right">
                    <div className="button"> View </div>
                  </div>
                  <ul className="specs__list">
                    {deal?.highlights?.slice(0, 2)?.map((item) => {
                      return (
                        <li
                          className="specs__item"
                          dangerouslySetInnerHTML={{ __html: item }}
                          key={`${deal.id}_${item.slice(0, 10)}`}
                        />
                      );
                    })}
                  </ul>
                </div>
              </a>
            </div>
          );
        })}
      </div>
      {enableWelcome && (
        <DiscountCoupon onClose={() => setEnableWelcome(false)} />
      )}
      <style jsx>{`
        .container {
          display: flex;
          flex-flow: wrap;
          -webkit-box-pack: justify;
          justify-content: space-between;
          -webkit-box-align: stretch;
          align-items: stretch;
          padding-top: 20px;
          margin-bottom: -20px;
          padding: ${isMobile ? '0' : '20px 15px'};
        }
        .deal-card {
          cursor: pointer;
          margin: 20px;
          border-radius: ${isMobile ? '5px' : '10px'};
          overflow: hidden;
          background-color: #ffffff;
          box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 5px;
          backface-visibility: hidden;
          transform: translate3d(0px, 0px, 0px);
          margin: 0px 0px 20px;
          width: ${isMobile ? '100%' : '49%'};
          max-height: ${isMobile ? '540px' : '690px'};
        }
        .deal-card > a {
          text-decoration: none !important;
        }
        .image-box {
          height: auto;
          position: relative;
          width: 100%;
        }

        .headline-text {
          margin: 5px 15px;
          color: #000000;
          text-decoration: none;
        }
        .button {
          background-color: #0000eb;
          border-radius: 2rem;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          font-size: 18px;
          font-weight: bold;
          height: 39px;
          justify-content: space-around;
          padding: 0px 1rem;
          text-align: center;
          text-decoration: none;
          text-transform: uppercase;
          width: 96px;
        }
        .left {
          float: left;
          width: 65%;
        }
        .right {
          float: right;
          margin: ${isMobile ? '10px' : '15px'};
        }
        .specs__list {
          float: left;
        }
        .specs__item {
          color: #000000;
          margin: 5px;
          text-decoration: none;
        }
        .grey-text {
          color: #999999;
          margin: 0 15px;
          font-size: 12px;
          text-decoration: none;
        }
        .merchant {
          font-size: 14px;
          margin: 5px 15px;
        }
        .rating {
          font-size: 14px;
        }
      `}</style>
    </>
  );
};

FindFeed.propTypes = {
  deals: PropTypes.array,
  isMobile: PropTypes.bool,
  isSpaPage: PropTypes.bool,
  ssr: PropTypes.bool,
};

export default FindFeed;
